/* --- EXACT-STYLE WHITE-LINE ICONS --- */
const common = { width: 26, height: 26, viewBox: "0 0 24 24",
    fill: "none", stroke: "currentColor", strokeWidth: 1.9,
    strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };
  
  const IconShield = () => (
    <svg {...common}>
      {/* classic shield */}
      <path d="M12 3.2 19 6v5.1c0 4.6-3.2 8.6-7 9.8-3.8-1.2-7-5.2-7-9.8V6l7-2.8z"/>
      {/* optional inner tick – remove if you want plain shield */}
      <path d="M9.2 12.6 11 14.4 14.8 10.6"/>
    </svg>
  );
  
  const IconBadgeCheck = () => (
    <svg {...common}>
      {/* rosette/badge with subtle scallops */}
      <path d="M12 3l2 1.7 2.6.6.6 2.6L19 10l-1.8 2 .6 2.6-2.6.6L12 17l-2.2-1.8-2.6-.6L7 12 5 10l1.8-2-.6-2.6 2.6-.6L12 3z"/>
      <path d="M8.8 12l2 2 4.2-4.2"/>
    </svg>
  );
  
  const IconHourglass = () => (
    <svg {...common}>
      <path d="M6 3h12M6 21h12"/>
      <path d="M6 3c0 4.5 5 5.6 6 7.6 1-2 6-3.1 6-7.6"/>
      <path d="M6 21c0-4.5 5-5.6 6-7.6 1 2 6 3.1 6 7.6"/>
    </svg>
  );
  
  const IconChatDots = () => (
    <svg {...common}>
      {/* rounded bubble */}
      <path d="M20 14a5 5 0 0 1-5 5H9l-4 3v-3H6a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h9a5 5 0 0 1 5 5v6z"/>
      {/* dots */}
      <circle cx="10" cy="11.5" r="1"/>
      <circle cx="13" cy="11.5" r="1"/>
      <circle cx="16" cy="11.5" r="1"/>
    </svg>
  );
  
  /* Use these in your features array */
  const features = [
    { icon: <IconShield/>,      title: "Secure & Confidential", desc: "Bank-level security protocols ensure your sensitive legal information remains protected throughout every interaction." },
    { icon: <IconBadgeCheck/>,  title: "Verified Experts",      desc: "All lawyers undergo rigorous verification including credential checks, experience validation, and client review assessment." },
    { icon: <IconHourglass/>,   title: "Efficient Process",     desc: "Streamlined workflows and smart matching algorithms reduce waiting times and accelerate legal service delivery." },
    { icon: <IconChatDots/>,    title: "Transparent Communication", desc: "Clear, straightforward communication at every step, so you understand your options, the process, and what to expect. " },
  ];
  
  
  function WhyCard({ icon, title, desc }) {
    return (
      <div className="cl-why-card">
        <div className="cl-why-icon">
          <span className="cl-why-icon-inner">{icon}</span>
        </div>
        <div>
          <h3 className="cl-why-title">{title}</h3>
          <p className="cl-why-desc">{desc}</p>
        </div>
      </div>
    );
  }
  
  export default function WhyChooseSection() {
    return (
      <section className="cl-why">
        <div className="cl-container">
          <div className="cl-why-head">
            <h2 className="cl-title center cl-why-heading">Why Choose Click Law</h2>
          </div>
  
          <div className="cl-why-grid">
            {features.map((item, idx) => (
              <WhyCard key={idx} {...item} />
            ))}
          </div>
        </div>
      </section>
    );
  }
  